import { Container, Dialog, DialogContent, Divider, Grid, IconButton, Typography } from '@material-ui/core';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import {
  Add as AddIcon, BackspaceOutlined as BackspaceOutlinedIcon, Delete as DeleteIcon, Search as SearchIcon
} from '@material-ui/icons';
import MUIDataTable from "mui-datatables";
import { useSnackbar } from 'notistack';
import React, { useCallback, useEffect, useState } from 'react';
import { useForm } from "react-hook-form";
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import SelectRackType from '../../components/Form/SelectRackType';
import Success from '../../components/Form/Success';
import AlertDialog from '../../components/ui/AlertDialog';
import ButtonUI from '../../components/ui/ButtonUI';
import LoadingUI from '../../components/ui/LoadingUI';
import PageTitle from '../../components/ui/PageTitleUI';
import { useAuth } from '../../hooks/auth';
import { PackingFCMSearch } from '../../interfaces/PackingFcm';
import MvmApi from '../../services/MvmApi';
import getDefaultGridOptions from '../../utils/componentUtils';
import utilsDate from "../../utils/Date";
import permissions from '../../utils/Permissions';
import useKeypress from '../../utils/useKeypress';
import PackingFCMForm from './PackingFCMForm';
import { DialogTitle, PaperComponent, useStyles } from './Style';




const opcoes = [
  { url: '/packingfcm', descricao: 'Incluir', state: { openPanelOnLoad: true } },
  { url: '/packingfcm', descricao: 'Pesquisar', state: {} }
]

interface Params {
  openPanelOnLoad: boolean;
}

const PackingFcm: React.FC = () => {
  const classes = useStyles();
  const location = useLocation<Params>();
  const [causals, setCausals] = useState<any>();
  const [loading, setLoading] = useState(true);
  const [openedPainel, setOpenedPainel] = React.useState(false);
  const [causalCode, setCausalCode] = useState<string>("");
  const { user, hasPermission } = useAuth();
  const { t } = useTranslation("PackingFcm");
  const { t: _t } = useTranslation("General");
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const [submitData, setSubmitData] = useState<PackingFCMSearch>();
  const [refetch, setRefetch] = useState(false);

  const [page, setPage] = useState(0)
  const [count, setCount] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(10)

  const [success, setSuccess] = useState(false);

  useEffect(() => {
    // if (user.permissions.filter(item => item === 'CONSULTAR_CAUSAL').length <= 0) {
    //     history.push('/Blanc');
    // }

    // OptionValueApi.searchStatus('TipoUsuerCausal').then(response => {
    //     if (response) {
    //         setOptionsResponsibleUser(response.map(
    //             (status: any) => ({
    //                 value: status.code, text: status.description
    //             })));
    //     }
    // });

  }, [history, user]);

  useEffect(() => {
    if (!hasPermission(permissions.FCM.Search))
      history.replace('NoPermission');

    setCausals([]);
    setLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history, user]);

  useEffect(() => {
    if (submitData === null || submitData === undefined)
      return;

    var objectString = JSON.stringify(submitData);
    var object = null;

    if (objectString !== null && objectString !== undefined)
      object = JSON.parse(objectString);

    var submitObject: PackingFCMSearch = {
      RackTypeCode: object?.RackTypeCode?.code,
      CompanyId: user.company.companyID,
      pageSize: rowsPerPage,
      pageIndex: page
    };

    searchPackingFcm(submitObject);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [submitData, refetch]);

  useEffect(() => {
    var data = getValues();
    setSubmitData(data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, rowsPerPage]);

  const columns = [
    { //1
      name: 'id',
      options: {
        display: false
      }
    },
    { //2
      name: 'rackTypeCode',
      label: t("fcmCode"),
      options: {
        sort: false,
        setCellProps: () => ({
          align: "left"
        }),
        display: false
      }
    },
    { //3
      name: 'packingDescriptionCode',
      label: t("fcm"),
      options: {
        sort: false,
        setCellHeaderProps: () => ({
          align: "center",
        }),
        setCellProps: () => ({
          align: "center"
        }),
        customBodyRender: (value: any, tableMeta: any, updateValue: any) => (
          <span>{tableMeta.rowData[1] + " - " + value}</span>
        )
      }
    },
    { //4
      name: 'updatedBy',
      label: _t("updatedBy"),
      options: {
        sort: false,
        setCellHeaderProps: () => ({
          align: "center",
        }),
        setCellProps: () => ({
          align: "center"
        })
      }
    },
    {
      name: "updatedAt",
      label: _t("updatedAt"),
      options: {
        setCellHeaderProps: () => ({
          align: "center",
        }),
        setCellProps: () => ({
          align: "center"
        }),
        disableClick: true,
        sort: false,
        customBodyRender: utilsDate.DateTimeShort

      }
    },
    {
      name: "",
      options: {
        setCellProps: () => ({
          align: "right"
        }),
        disableClick: true,
        sort: false,
        customBodyRender: (value: any, tableMeta: any, updateValue: any) => (
          renderButtons(tableMeta.rowData[0])
        )
      }
    },

  ];

  const renderButtons = (id: any) => {
    return (
      <AlertDialog
        dialogTitle={_t("dialogDeleteTitle")}
        dialogContentText={_t("dialogDeleteContentText")}
        cancelTextButton={_t("cancelDeleteTextButton")}
        confirmTextButton={_t("confirmDeleteTextButton")}
        confirmDialogFunction={() => { handleDeleteItem(id); }}
        Button={
          <IconButton disabled={!hasPermission(permissions.FCM.Delete)} size='small' edge="end">
            <DeleteIcon />
          </IconButton>
        }
      />
    );
  };

  function handleDeleteItem(id: number) {
    setLoading(true);
    MvmApi.deletePackingFCM(id)
      .then(result => {
        setLoading(false);
        enqueueSnackbar(t("returnSubmitDeleteFormSuccess"), { variant: 'success' });
      }).catch(() => {
        setLoading(false)
      }).finally(() => {
        setRefetch(!refetch)
      });
  };

  useKeypress('Escape', () => {
    setOpenedPainel(false);
  });

  const searchPackingFcm = useCallback(
    async (data: PackingFCMSearch) => {

      setLoading(true);

      MvmApi.searchPackingFCM(data)
        .then(result => {
          if (result && result.items) {

            setCount(result.totalCount)
            setPage(result.pageIndex)
            setCausals(result);
          }
          else {

            setCausals([]);
          }
        }).catch(() => {
          setCausals([]);
        }).finally(() => {
          setLoading(false);
        });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  const { handleSubmit, reset, control, getValues, setValue } = useForm<any>(
    {
      defaultValues: { RackTypeCode: "" }
    });

  const handleOpenPanelChange = (id: any) => {
    setCausalCode(id);
    setOpenedPainel(true);
  };

  const callbackDialogHandle = () => {
    setOpenedPainel(false);
  }

  const myTheme = createMuiTheme({
    overrides: {
      MuiTableBody: {
        root: {
          cursor: causals?.items ? 'pointer' : ''
        }
      }
    }
  })

  useEffect(() => {
    if (location.state?.openPanelOnLoad) {
      setOpenedPainel(true);
      setCausalCode("")
    }
  }, [location.state?.openPanelOnLoad])

  if (success)
    return (
      <Container maxWidth={false} component="main">
        <div className={classes.rootContent}>
          <div className={classes.paper}>
            <Success opcoes={opcoes} />
          </div>
        </div>
      </Container>
    )
  else
    return (
      <Container maxWidth={false} component="main">

        <Dialog
          open={openedPainel}
          aria-labelledby="form-dialog-title"
          PaperComponent={PaperComponent}
          onBackdropClick={() => setOpenedPainel(false)}
          fullWidth
        >
          <DialogTitle classes={{ root: classes.dialogTitle }}
            id="draggable-dialog-title"
            onClose={() => setOpenedPainel(false)}>
            {causalCode !== "" ? t("editTitle") : t("addTitle")}
          </DialogTitle>
          <DialogContent>
            <PackingFCMForm causalCode={causalCode} handleSetSuccess={setSuccess} clickHandlerCalbkack={callbackDialogHandle} clickHandlerClose={() => setOpenedPainel(false)} />
          </DialogContent>

        </Dialog>

        <PageTitle title={t("controlledFcmTitle")} />
        <div className={classes.rootContent}>
          <div className={classes.paper}>

            <form translate={undefined} onSubmit={handleSubmit(data => { setSubmitData(data); })}>

              <Grid container spacing={1}>
                <Grid item xs={6} style={{ padding: "0px", display: 'flex', alignItems: 'center' }}>
                  <Typography className={classes.root}>
                    Pesquisar Embalagens FCM
                  </Typography>

                </Grid>

                <Grid item xs={6} style={{ padding: "0px", textAlign: 'right' }}>
                  <ButtonUI disabled={!hasPermission(permissions.FCM.Add)} color="secondary" onClick={() => { setOpenedPainel(true); setCausalCode("") }} startIcon={<AddIcon />}>{t("add")}</ButtonUI>
                  <ButtonUI onClick={() => reset()} startIcon={<BackspaceOutlinedIcon />}>{t("clean")}</ButtonUI>
                  <ButtonUI type="submit" color="primary" startIcon={<SearchIcon />}>{t("search")}</ButtonUI>
                </Grid>
              </Grid>

              <Divider style={{ marginTop: '10px' }} />

              <Grid container spacing={1}>
                <Grid item xs={2}>
                  <SelectRackType
                    label={t("fcmCode")}
                    name="RackTypeCode"
                    control={control}
                    style={{ width: '100%' }}
                    multiple={false} />
                </Grid>
              </Grid>
            </form>

            {
              loading ? <LoadingUI /> :
                <MuiThemeProvider theme={myTheme}>
                  <MUIDataTable
                    title=""
                    data={causals?.items}
                    columns={columns}
                    options={{
                      ...getDefaultGridOptions(_t),
                      serverSide: true,
                      pagination: true,
                      sort: causals?.items ? true : false,
                      selectToolbarPlacement: "none",
                      filter: false,
                      search: false,
                      download: false,
                      print: false,
                      viewColumns: false,
                      selectableRows: 'none',
                      // onRowClick: (row, index) => {
                      //     handleOpenPanelChange(row[0]);
                      // },
                      page,
                      count,
                      rowsPerPage,
                      onCellClick: (colData, { colIndex, dataIndex }) => {
                        if (hasPermission(permissions.FCM.Edit))
                          if ((causals && causals.items) && colIndex < 5) {
                            handleOpenPanelChange(causals.items[dataIndex].id);
                          }
                      },
                      onChangePage: (pageIndex) => { setPage(pageIndex) },
                      onChangeRowsPerPage: (rowsPerPage) => { setPage(0); setRowsPerPage(rowsPerPage) },
                    }}
                  />
                </MuiThemeProvider>
            }
          </div>
        </div>
      </Container>
    )
}
export default PackingFcm;
